<template>
  <div class="container">
    <el-transfer
      class="list"
      v-for="(item, index) in levels"
      :key="index"
      v-model="values[index]"
      :data="rights"
      :titles="[`level${item}`, `level${item}已选功能`]"
      @change="handleChange(item, values[index])"
    ></el-transfer>
  </div>
</template>

<script>
import request from '../../api/request'
import { RIGHTS_CN } from '../../define'
export default {
    data() {
        return {
            levels: [1,2],
            rights: [],
            values: [], // [{}, .... ]
        }
    },
    created() {
        this.getRights()
        this.getLevelData()
    },
    methods: {
        handleChange(level, value) {
            this.onchange(level, value)
        },
        async getLevelData() {
            let values = []
            const resp = await request.tools.post('user_level_rights_list', {
                range: [0, 1e6],
            })
            const list = this.levels.map((l) => {
                return this.filterLevelData(resp.data.list, l)
            })
            for (let i = 0; i < list.length; i++) {
                values[i] = this.filterLevelIndex(list[i])
            }
            this.values = values
        },
        filterLevelIndex(data) {
            const list = []
            data.map((item) => {
                const rights = this.rights.map((item) => {
                    return item.value
                })
                const index = rights.indexOf(item.rights)
                if (index > -1) {
                    list.push(index)
                }
            })
            return list
        },
        filterLevelData(data, target) {
            return data.filter((v) => {
                return v.level === target
            })
        },
        onchange(level, value) {
            const levelList = value.map((item) => {
                return this.rights[item].value
            })
            request.tools.post('user_level_rights_set', {
                level: level,
                rights: levelList,
            })
        },
        async getRights() {
            const resp = await request.tools.post('user_level_rights', {})
            this.rights = resp.data.list.map((item, index) => {
                return {
                    label: RIGHTS_CN[`${item}`],
                    key: index,
                    value: item,
                }
            })
        },
    },
}
</script>

<style scoped>
.container {
    text-align: left;
}

.box {
    text-align: left;
    margin-top: 30px;
}
.button {
    margin-top: 30px;
}
label {
    margin-bottom: 15px;
}
.list {
  margin-top: 30px;
  padding-bottom: 30px;
  border-bottom:1px dashed #eaeaea;
}
</style>
